import { ApiError } from "../api/client";

export function ErrorBanner({ error, onRetry }: { error: ApiError | Error | null; onRetry?: () => void }) {
  if (!error) return null;
  const code = error instanceof ApiError ? error.code : null;
  const isWarming = code === "warming";

  return (
    <div className={`banner ${isWarming ? "banner-warn" : "banner-error"}`} role="alert">
      <div>
        <strong>{isWarming ? "Cache still filling" : "Error"}</strong>
        <p>{error.message}</p>
        {code && code !== "warming" ? <p className="muted">code: {code}</p> : null}
      </div>
      {onRetry ? (
        <button type="button" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
